import {Component, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {complaintStatuses} from "../../../../shared/types/custom-types";
import {ReportFilterModel} from "../../../../shared/model/request/report-filter.model";
import {ComplaintStatus} from "../../../../shared/enums/status.enum";
import {BaseUtil} from "../../../../shared/utils/base.util";

@Component({
    selector: 'app-report-filters',
    templateUrl: './report-filters.component.html',
    standalone: false
})
export class ReportFiltersComponent {

  form: FormGroup;

  @Output('submitFilter') submitEmitter = new EventEmitter<ReportFilterModel>()

  eventStatuses = BaseUtil.removeFromStatus(complaintStatuses())
  eventMaxDate: Date = new Date();

  constructor() {
  }

  ngOnInit(): void {
    this.form = new FormGroup<any>({
      "eventName": new FormControl(null),
      "reporterName": new FormControl(null),
      "reporteeName": new FormControl(null),
      "status": new FormControl(ComplaintStatus.PENDING),
      "reportDate": new FormControl(null),
    })
    this.onSubmit()
  }

  onClear() {
    this.form.reset()
    this.form.get('status').setValue(ComplaintStatus.PENDING)
    this.onSubmit();
  }

  onSubmit() {
    this.submitEmitter.emit(this.form.value)
  }
}
